import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { AlertCircle, Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-orange-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        {/* 404 Header */}
        <div className="mb-8">
          <div className="flex justify-center items-center mb-6">
            <AlertCircle className="h-24 w-24 text-[#C08B89] mr-4" />
            <div>
              <h1 className="text-8xl sm:text-9xl lg:text-[10rem] font-bold bg-gradient-to-r from-[#C08B89] to-pink-600 bg-clip-text text-transparent leading-none">
                404
              </h1>
              <p className="text-sm text-gray-500 mt-2">Oops!</p>
            </div>
          </div>
          <Card className="max-w-2xl mx-auto border-2 border-[#C08B89]/20">
            <CardHeader className="pb-4">
              <CardTitle className="text-3xl font-bold text-gray-900">
                Page Not Found
              </CardTitle>
              <CardDescription className="text-lg text-gray-600">
                The page you&apos;re looking for doesn&apos;t exist or has been moved.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-muted-foreground">
                Don&apos;t worry, our delicious cakes and pastries are still waiting for you!
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
                <Button asChild size="lg" className="bg-[#C08B89] hover:bg-[#C08B89]/90 text-white shadow-lg">
                  <Link to="/" className="flex items-center gap-2">
                    <Home className="h-5 w-5" />
                    Go to Homepage
                  </Link>
                </Button>
                <Button asChild variant="outline" size="lg">
                  <Link to="/ramzan-special-food" className="flex items-center gap-2">
                    <ArrowLeft className="h-5 w-5" />
                    Ramzan Specials
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Optional decorative elements */}
        <div className="mt-16 text-sm text-gray-500">
          <p>Try searching or use the menu to navigate back.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;

